import axios from "axios";
import Qs from 'qs';

const instance = axios.create({
    // baseURL: "/api",
    baseURL: "https://bqwapi.bangqichat.com",
    // baseURL: "http://192.168.0.173:28082",
});
// 配置拦截器
instance.interceptors.request.use(async (config) => {
    // 批量处理post请求
    if (config.data) {
        if (config.method === "post" && config.data.request == "form") {
            config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            config.data = Qs.stringify(config.data);
        }
    } else if (config.method === "post") {
        config.data = {}
    }
    //登录后请求时加上token与uid
    /* if (sessionStorage.getItem('hasLogin') && sessionStorage.getItem('hasLogin')=='true') {
         config.data.uid = JSON.parse(sessionStorage.getItem('loginData')).cid;
     }*/
    if (localStorage.getItem('token')) {
        config.headers['token'] = localStorage.getItem('token');
    }
    /*允许所有来源访问 */
    config.headers['Access-Control-Allow-Origin'] = '*';
    /*这个属性主要是设置浏览器优先使用什么模式来渲染页面的。代码IE=edge告诉IE使用最新的引擎渲染网页,这个在需要兼容IE浏览器的情况下都可以加上这句话*/
    config.headers['http-equiv'] = 'X-UA-Compatible';
    config.headers['content'] = 'IE=EDGE';
    return config;
}), (err) => {
    return Promise.reject(err);
};
// 响应拦截器
instance.interceptors.response.use((res) => {
        if (res.data.code == 403) {
            console.log(res.data.content);
            history.go(-1);
            return Promise.reject(res.data);
        } else if (res.data.code == 200) {
            let reg = new RegExp('https', 'g')//g代表全部
            if (res.data.content) {
                if (res.data.content !== undefined && res.data.content.length > 0) {
                    for (let i = 0; i < res.data.content.length; i++) {
                        if (res.data.content[i].hasOwnProperty("image")) {
                            res.data.content[i].image = res.data.content[i].image.replace(reg, 'http');
                        }
                        if (res.data.content[i].keyword) {
                            res.data.content[i].keyword = res.data.content[i].keyword.replace(reg, 'http');
                        }
                        if (res.data.content[i].hasOwnProperty("photo")) {
                            if (res.data.content[i].photo.length > 0) {
                                for (let p = 0; p < res.data.content[i].photo.length; p++) {
                                    res.data.content[i].photo[p] = res.data.content[i].photo[p].replace(reg, 'http');
                                }
                            }
                        }
                    }
                } else {
                    if (res.data.content.hasOwnProperty("image")) {
                        res.data.content.image = res.data.content.image ? res.data.content.image.replace(reg, 'http') : '';
                    }
                    if (res.data.content.hasOwnProperty("keyword")) {
                        res.data.content.keyword = res.data.content.keyword ? res.data.content.keyword.replace(reg, 'http') : null;
                    }
                    if (res.data.content.hasOwnProperty('content')) {
                        res.data.content.content = res.data.content ? res.data.content.content.replace(reg, 'http') : null;
                    }
                }
            }
        }
        return res.data;
    }, (err) => {
        console.log("服务器错误！");
        return Promise.reject(err);
    }
);
export default instance;